<template>
<div class="chapter">
<div class="inner_page">
<div style="margin-top:2em; margin-bottom:4em">
</div>
<hr class="sigil_split_marker"/>
<div class="ce mb01" id="pgepubid00000">
<h1 style="margin-bottom:0em;">
    An Art Shop in Greenwich Village
   </h1>
<div>
    By Ray Cummings
   </div>
</div>
<div class="mt01 mb01 w001" id="id_001">
<img alt="" id="id-2500500189721566499" src="8158394740058291626_illus-001.jpg" style="width:100%"/>
</div>
<p>
   The little shop was dimly lighted—a lurid red glow at one side and a 
faint amber radiance from above. For a moment I stood looking around 
uncertainly—at the slovenly display-cases and tables, the unframed 
paintings on the walls, and the long shelves crowded with curios.
  </p>
<p>
   “Perhaps something in particular the
   <i>
    señor
   </i>
   would wish?” 
suggested the little old man ingratiatingly.
  </p>
<p>
   I glanced back into the black shadow that shrouded the farther end of 
the room, and then turned to meet the snakelike little eyes that were 
roving over my figure appraisingly.
  </p>
<p>
   I shook my head. “No,” I said; “nothing in particular.”
  </p>
<p>
   The little old man straightened his bent back with an effort, reaching 
a skinny hand toward the shelf above his head.
  </p>
<p>
   “The
   <i>
    señor
   </i>
   plays chess, perhaps?” His hand held a little white 
figure carved in ivory; he dusted it off against the faded black of his 
coat-sleeve. “A wonderful game,
   <i>
    señor
   </i>
   . This set is of the Moors—they
carve superb in ivory, the Moors. Perhaps in the London Museum of 
Victoria and Albert the
   <i>
    señor
   </i>
   has seen the work before?”
  </p>
<p>
   “No,” I said, and moved away down the length of the table. “I lived in 
Spain a year. Your place interests me.”
  </p>
<p>
   He laid aside the ivory figure and followed me down the room with 
feeble steps; I noticed then that one of his feet dragged as he walked. It 
was peculiarly unpleasant—indeed the whole personality of this decrepit 
little old man seemed unpleasant and repulsive. I stopped in the red glow 
of an iron lantern that hung from a bracket upon the wall.
  </p>
<p>
   “I lived in Spain a year,” I repeated. “That is why, when I saw your 
sign, I stopped in to look around.”
  </p>
<p>
   He stood beside me, looking up into my face, his head shaking with the 
palsy of old age, his eyes gleaming into mine.
  </p>
<p>
   “In
   <i>
    España
   </i>
   you have lived, eh?” The thin, cracked treble of his 
voice came from lips that parted in a toothless smile. “That is good—very 
good,
   <i>
    señor
   </i>
   .”
  </p>
<p>
   “In Granada,” I added briefly.
  </p>
<p>
   He put a shaking hand upon my arm; involuntarily I drew back from his 
touch.
  </p>
<p>
   “The
   <i>
    señor
   </i>
   has lived in Granada! My birthplace,
   <i>
    señor
   </i>
   —yet 
for fifteen years have I been here in your New York. Fifteen years, 
selling here the treasures of
   <i>
    España
   </i>
   . You have lived in Granada—ah, 
then,
   <i>
    señor
   </i>
   , the Alhambra you have seen?”
  </p>
<p>
   “Yes,” I said, “of course.”
  </p>
<p>
   He picked up a little vase from the table before us. The fire of 
patriotism that for an instant had lighted his face was gone; cupidity 
marked it instead.
  </p>
<p>
   “The
   <i>
    señor
   </i>
   perhaps is interested in ceramics?” His voice was 
almost a whine. “The great Alhambra vase—greatest example of the ceramic 
art of the Moors in all the world—here is its miniature,
   <i>
    señor
   </i>
   .
See—gazelles in cream and golden luster upon a blue field.
  </p>
<p>
   “And there—over there you see a Moorish plate, painted with a luster of 
blue and copper. And there—the golden pottery of Malaga—you have heard of 
that,
   <i>
    señor
   </i>
   ?
   <i>
    Madre miu
   </i>
   , what beautiful pottery they 
made—those Musselmen of Malaga!” He pointed at the lower shelf. “See it 
gleam,
   <i>
    señor
   </i>
   like purest gold. But to you,
   <i>
    señor
   </i>
   , you who 
have been to
   <i>
    España
   </i>
   —because we understand these things, you and 
I—will I sacrifice my treasure.”
  </p>
<p>
   “No,” I said. “The price does not matter.”
  </p>
<p>
   On the wall, above the red glow of the lantern, hung an unframed 
canvas. In the amber light that shone on it from above I could see its 
great splashes of color—the glittering, gaudy parade of a bull-ring.
  </p>
<p>
   “That painting there,” I asked—“what is that?”
  </p>
<p>
   Again he put his hand upon my arm, and I felt myself shiver in the 
close, warm air of the room.
  </p>
<p>
   “The
   <i>
    señor
   </i>
   perhaps is rich?” His voice came hardly above a 
whisper; he strained upward toward my face as though to exchange some 
darkly mysterious secret.
   <i>
    Un Americano rico
   </i>
   ,” he said, “and the 
money perhaps does not matter?”
  </p>
<p>
   “Perhaps,” I said, and shook off his hold upon my arm.
  </p>
<p>
   “If that be so,
   <i>
    señor
   </i>
   , there are many among my treasures I could 
show.”
  </p>
<p>
   “I have no money with me to-night,” I said.
  </p>
<p>
   He raised his hand deprecatingly. “Naturally,
   <i>
    señor
   </i>
   . 
We understand each other. To have money in the pocket—it makes no 
importance if one understands.”
  </p>
<p>
   I glanced up again at the vivid, colorful bull-ring pictured upon the 
wall. His eyes followed mine.
  </p>
<p>
   “Francisco Goya,” he said. “Greatest in
   <i>
    España
   </i>
   to follow the 
great Velasquez.”
  </p>
<p>
   “You mean that is an original Goya?” I exclaimed.
  </p>
<p>
   His voice fell again to whining. “Ah,
   <i>
    señor
   </i>
   , no more can I tell 
you than they told to me. You, perhaps, who are of the art a judge—you can 
say if indeed it is of Goya.”
  </p>
<p>
   He waited, but I did not answer.
  </p>
<p>
   “A person very droll,
   <i>
    señor
   </i>
   —the great Goya. A fighter in the 
bull-ring once, before he took the brush. And with the women—
   <i>
    Madre 
mia
   </i>
   , how they loved him—those women in the court of the fourth 
Charles! He painted well,
   <i>
    señor
   </i>
   . And his pictures of the 
bull-ring—like that,
   <i>
    señor
   </i>
   ”—his hands went up as though in 
benediction—“there are none better.”
  </p>
<p>
   I stood for a moment looking up at the painting.
  </p>
<p>
   “If the
   <i>
    señor
   </i>
   wishes,” he added softly, “it troubles me not to 
take it down.”
  </p>
<p>
   I shook my head, “A realist, this Goya,” I said.
  </p>
<p>
   “He had no heart,
   <i>
    señor
   </i>
   . What he saw he painted without pity. He 
was, as you would say, a satirist.”
  </p>
<p>
   I had no idea that the painting before me was genuine—nor indeed did I 
much care. But this little, withered old man, and his musty, cobweb-laden 
shop, had about them something vaguely sinister that fascinated me—a 
subtle sense of mystery I could not escape.
  </p>
<p>
   “I have studied art,” I said. “You interest me.”
  </p>
<p>
   Again I met his glittering eyes, and it struck me then, I think for the 
first time, that there was in them a light that was not the light of 
reason.
  </p>
<p>
   For an instant I could see him hesitate, and then as though he had 
reached a sudden decision, he motioned me to a chair and seated himself, 
facing me in the red glow of the lantern overhead.
  </p>
<p>
   “The
   <i>
    señor
   </i>
   is very young,” he began softly; again he hesitated, 
glancing swiftly over his shoulder as if to reassure himself that there 
was no one else in the room. “Very young,
   <i>
    señor
   </i>
   , but also—shall we 
say —very rich?”
  </p>
<p>
   His eyes were fastened upon mine; the red beam from the lantern lighted 
his hollow cheeks with a weird, unearthly light. I took off my hat and 
laid it on the table at my side.
  </p>
<p>
   “That need not concern us,” I said.
  </p>
<p>
   “
   <i>
    Muy bien, señor
   </i>
   . We understand each other
   <i>
    segurimente
   </i>
   . Of 
the character I am judge—for I am an old
   <i>
    señor
   </i>
   , and many people 
have I known.”
  </p>
<p>
   He pulled a watch from his pocket. “The hour is late. No one comes to 
buy.” He rose to his feet and locked the door that led to the street.
  </p>
<p>
   “That is better,
   <i>
    señor
   </i>
   .” He came back toward me with his 
tottering, dragging step, and switched off the amber light in the ceiling. 
“The
   <i>
    señor
   </i>
   will remove his storm-coat?”
  </p>
<p>
   I laid my overcoat on the table and sat again in the little wicker 
chair. The shadows of the room were close around us now. In the heavy red 
of the light I could see only a corner of the table and the shaking figure 
of the little old man as he sat facing me. Behind him the solid blackness 
had crept up like a wall.
  </p>
<p>
   “
   <i>
    Bien, señor
   </i>
   . That is well. Now we talk.”
  </p>
<p>
   I felt my pulse quicken a little; but I held my gaze firm to his.
  </p>
<p>
   “Only to you,
   <i>
    señor
   </i>
   , would I say what now you shall hear.” His 
glance shifted upward into the darkness, then back again to mine.
  </p>
<p>
   “Francisco Goya, Velasquez, Sorolla y Bastida—all these great men of
   <i>
    España
   </i>
   are known to the
   <i>
    señor
   </i>
   . Is it not so?”
  </p>
<p>
   I nodded.
  </p>
<p>
   “But one there is—we shall call him Pedro Vasquez y Carbajál—of him the
   <i>
    señor
   </i>
   has never heard?”
  </p>
<p>
   “No,” I said; “I have never heard of him.”
  </p>
<p>
   He leaned forward in his chair again; his locked fingers in his lap 
writhed upon each other like little twisting snakes.
  </p>
<p>
   “A wonderful painter,
   <i>
    señor
   </i>
   , for he knew the secret to put life 
upon his canvas.” His voice fell to a sibilant whisper.
  </p>
<p>
   “Vasquez y Carbajál,” I replied. “No, I never heard of him.”
  </p>
<p>
   “Only one picture,
   <i>
    señor
   </i>
   , to make him famous. Very old he is, 
this Vasquez. One picture to make him famous. Five years it has taken him. 
Five years of working—working—” His voice trailed off into silence.
  </p>
<p>
   “Yes?” I prompted.
  </p>
<p>
   His head had sunk to his breast; he raised it with a start at my word. 
The fire came back to his eyes; he sat up rigid in his chair.
  </p>
<p>
   “A picture of the kind none other could paint,
   <i>
    señor
   </i>
   . The secret 
to put life upon canvas. Is that not droll?” His querulous, half maniacal 
laughter echoed across the shadowed room. “From the mortal living,
   <i>
    señor
   </i>
   , we take the life, and upon the canvas we make it 
immortal.”
  </p>
<p>
   I pushed my chair backward violently, half starting to my feet.
  </p>
<p>
   “Stay,
   <i>
    señor
   </i>
   .” He raised his hand, pointing a finger at me. “You 
who are of the art a judge—you would see this painting, no? This picture 
by the great Vasquez that soon will be seen by all the world?”
  </p>
<p>
   He laughed again—an eery laugh that chilled my blood.
  </p>
<p>
   “One moment,
   <i>
    señor
   </i>
   —one little moment, and your eyes shall see 
that which they have never seen before.” He rose to his feet unsteadily. 
“Life upon canvas,
   <i>
    señor
   </i>
   . And beauty—vivid and real to make your 
pulses beat strong.”
  </p>
<p>
   I stood beside him under the lantern.
  </p>
<p>
   “We shall look upon it together, you and I.” He raised a hand 
apologetically. “That is, of course—if the
   <i>
    señor
   </i>
   desires.” The 
mystery his words implied appealed to me—I was in my twenties then—and to 
the spirit of adventure that has always been strong in me. It was 
chicanery, I knew, but interesting, and I would see it through.
  </p>
<p>
   “Very well,” I said. “I will look at your painting.”
  </p>
<p>
   In silence I followed him into the shadows of the back of the room.
  </p>
<p>
   “Careful,
   <i>
    señor
   </i>
   —a chair is here.”
  </p>
<p>
   He suddenly drew aside a curtain in the darkness, and we stepped into a 
dim hallway, with a narrow flight of stairs leading to the floor 
above.
  </p>
<p>
   “I shall go in front,
   <i>
    señor
   </i>
   . You will follow. The way is not 
long, and there is light.”
  </p>
<p>
   The stairs were narrow and uncarpeted; they creaked a little under our 
tread. On the landing a window stood partly open, its shade flapping in 
the wind. The snow on the ledge outside had drifted in over the sill.
  </p>
<p>
   We stopped on the landing, and the old man closed the window softly.
  </p>
<p>
   “We speak not so loud now,
   <i>
    señor
   </i>
   , so—” He broke off abruptly. 
“It is better we speak not so loud now,” he finished.
  </p>
<p>
   At the top of the stairs we turned back and passed through a doorway 
into a room that evidently was immediately over the one we had just 
left.
  </p>
<p>
   It was a room perhaps thirty feet in length and half as broad. My first 
impression as I stepped over the threshold was that I had stepped across 
the world—in one brief instant transported from the bare, ramshackle, 
tumbledown Bohemianism of Greenwich Village, into the semibarbaric, 
Levantine splendor of some Musselman ruler. The room was carpeted with 
Oriental rugs; its walls were hung with tapestries; its windows shrouded 
with portieres. Moorish weapons—only symbols now of the Mohammedan reign 
over Spain—decorated the walls. Two couches were piled high with vividly 
colored pillows.
  </p>
<p>
   The rugs and all the hangings were somber in tone. The whole room bore 
an air of splendid, lavish luxury; and yet there was about it something 
oppressive—a brooding silence, perhaps, or the heavy scent of incense.
  </p>
<p>
   “My room of work,
   <i>
    señor
   </i>
   ,” said the little old man softly, 
closing the door behind us.
  </p>
<p>
   I noticed then that there was one other door to the room, in the side 
wall near the front where there were two very large windows almost like a 
side skylight; and that this other door stood slightly ajar.
  </p>
<p>
   There was a huge fireplace with a blazing log-fire. I think that 
without its cheery crackle the oppressive feeling of mystery that hung 
over the room would have been almost unbearable.
  </p>
<p>
   “We shall have more light,
   <i>
    señor
   </i>
   .” The room was lighted only by a 
wavering yellow glow from the fire. He touched a switch, and from above 
came a flood of rose-colored light that bathed us in its sensuous 
warmth.
  </p>
<p>
   Over by the windows a large canvas, its face covered with a cloth, 
stood upon an easel; in front of the easel, nearer the side of the room, 
by the fireplace, I saw there was a model stand—a small board platform 
resting on the floor.
  </p>
<p>
   “You have a luxurious workshop,” I said casually.
  </p>
<p>
   The little old man looked over the room with an appraising, approving 
eye.
  </p>
<p>
   “One must have one’s ease,
   <i>
    señor
   </i>
   , when one creates.” He 
turned another switch, and a long row of hooded electric bulbs across the 
top of the windows cast their brilliant light directly downward upon the 
shrouded canvas.
  </p>
<p>
   “Come here,” he said. The whine had left his voice. He spoke the 
words as though now unconsciously he had slipped into the role of master, 
displaying to his pupil a great work of art.
  </p>
<p>
   He grasped me by the coat-sleeve, pulling me forward until I stood with 
my back against the portieres, and faced the shrouded canvas. Then 
abruptly he jerked down the cloth, and in the brilliant white glare from 
overhead the painting stood revealed.
  </p>
<p>
   I stared at the canvas. What I expected to see I do not know. What I 
saw left me gasping—first with amazement, then pity, then with 
an almost irrepressible desire to laugh. For upon the canvas was only a 
huge smear of many colored pigments—utterly formless, without meaning. I 
stared an instant, then turned and met the eyes of the little old man 
beside me. They gleamed into mine with triumph and pride, and in them I 
saw again—and this time plainly—the look of madness.
  </p>
<p>
   I held back the smile that struggled to my lips. “This—this painting—is 
it you who—”
  </p>
<p>
   “Is that not life,
   <i>
    señor
   </i>
   ?” His thin, treble voice carried an 
exultant, masterful note. “Can you not see it there? Human life—painted in 
with pigments to make it immortal.”
  </p>
<p>
   “Was it you who painted that—that picture?” A great pity rose in 
my heart for this poor, deluded madman.
  </p>
<p>
   “I? Oh,
   <i>
    señor
   </i>
   , you do me great honor. It was painted, I have 
said, by Vasquez—Pedro Vasquez y Carbajál. A wonderful man, this Vasquez. 
They are children beside him, these others. Is it not so?”
  </p>
<p>
   I said nothing, but gazed again at the miserably grotesque daubs on the 
canvas.
  </p>
<p>
   “Look,
   <i>
    señor
   </i>
   ! Is that not a soul you see in those eyes? A human 
soul?” He pointed a shaking finger at the smear of color before us, his 
eyes shining with pride. “You call them realists—these Goyas and these 
Zuloagas. You have seen the girls of Zuloaga, with their white faces and 
their lips of red. You have looked into their eves—these girls he 
paints—have you ever seen there the soul?
  </p>
<p>
   “‘Naturalism,’ they say; ‘a richness of tone!’ or ‘with a subtlety he 
paints.’ Or perhaps it is a ‘fuller impasto.’ Bah! They are but 
words—tricks of words for the critics to play with. They paint of life 
—these masters, as we call them—but their paintings are dead. They cannot 
capture the soul,
   <i>
    señor
   </i>
   —the soul that always struggles free—the 
human soul never can they hold imprisoned upon their canvas.
  </p>
<p>
   “And those lips,
   <i>
    señor
   </i>
   —see her beautiful red lips—are they 
not about to speak? The breath that trembles between them—is it not a 
little sigh she would breathe—a sigh to tell us she cannot understand this 
life that stirs within her?
  </p>
<p>
   “She would have music,
   <i>
    señor
   </i>
   —music to whisper those little woman 
secrets no man shall hear. See the lute she holds—her fingers have but 
brushed its strings, and she has laid it down.
  </p>
<p>
   “And that hand—there upon her breast. Closer,
   <i>
    señor
   </i>
   —bend closer. 
Can you not see veins upon that hand? Blue veins they are, but in them 
there is red blood flowing—red blood to feed the flesh of her body—blood 
to give her life and hold imprisoned there the soul. Can you not see it,
   <i>
    señor
   </i>
   ? Human blood—the blood of life in a portrait.”
  </p>
<p>
   His voice rose sharp and shrill with triumph, and he ended again with 
his horrible senile laughter.
  </p>
<p>
   The jangling of a bell rang through the house. The little old man met 
my glance and hesitated. Then as the ring was repeated—I could hear it 
now; it was in the shop down-stairs—he muttered a Spanish oath softly to 
himself.
  </p>
<p>
   “Some one wants to see me,” he said. “A customer, perhaps—who knows. 
The
   <i>
    señor
   </i>
   will excuse me one little moment?”
  </p>
<p>
   “Yes,” I said; “I will wait for you here.”
  </p>
<p>
   “When the business calls,
   <i>
    señor
   </i>
   , it is not 
good for the pleasure to interfere.” He looked around the room 
uncertainly, and then started for the door through which we had 
entered.
  </p>
<p>
   “I leave the
   <i>
    señor
   </i>
   not alone”—he glanced significantly at the 
canvas—“and only for one little moment.”
  </p>
<p>
   When he had left the room I stood again before the canvas, partly 
enveloped in the great folds of the heavy window portieres. On the stairs 
outside I could hear the dragging footsteps of the old man as he tottered 
back to the shop below. I examined the canvas more closely now. There was 
upon it every color and combination of color, like the heaped-up pigments 
on a huge, untidy palette. But I noticed that brown seemed to 
predominate—a dirty, drab, faded brown, inexpressibly ugly, and somehow 
very sinister. It seemed a pigment color I had never seen before. I could 
see, too, that the paints were laid on very thick—it was done in oils—as 
though it had been worked over and over again, for months or even 
years.
  </p>
<p>
   A light footfall sounded near at hand, a rustling of silk, the click of 
a latch. A girl stood in the partly opened side door—a young girl, hardly 
more than fifteen or sixteen, dressed in Moorish costume. She stood an 
instant hesitating, with her back partly turned to me, looking about the 
room. Then, leaving the door open behind her, she picked up a lute that 
was standing against the wall—I had net noticed before that it was 
there—and crossed the room toward the fireplace.
  </p>
<p>
   The girl crossed the room slowly; her back was still partly turned as 
she passed me. It took her but a moment to reach the fireplace, yet in 
that moment I had a vague but unmistakable feeling of being in the 
presence of an overpowering physical exhaustion. Her shoulders seemed to 
droop; she trailed the lute in her loose fingers over the heavy nap of the 
carpet; there was about her white figure as she walked a slackness of 
muscle, a limpness, a seeming absence of energy that was almost 
uncanny.
  </p>
<p>
   She reached the fireplace and sank on a hassock, holding the lute 
across her knees, her eyes staring away into the distance behind me. It 
was as though without conscious thought she had dropped into a model’s 
pose.
  </p>
<p>
   I must have stepped forward into plainer view, or made some slight 
noise, for the girl’s gaze abruptly shifted downward and met mine 
full.
  </p>
<p>
   “Oh,
   <i>
    señor
   </i>
   , I—” She showed no fear. She did not start to her 
feet, but sat quiet, as though in sudden bewilderment—yet with a mind too 
utterly exhausted to think clearly. “Oh,
   <i>
    señor
   </i>
   , I did not know. I 
thought only the
   <i>
    maestro
   </i>
   would be here, I came to pose for him. It 
is the hour.”
  </p>
<p>
   I tried to speak quietly. “He will be here in a moment,” I said. “I 
have been looking at your—your portrait.”
  </p>
<p>
   The girl did not smile, as I think I hoped she would, but stared at me 
apathetically. I held her glance a moment; then it wandered vaguely to the 
easel as though her thoughts were still groping with the import of my 
words.
  </p>
<p>
   In the shop down-stairs I could hear footsteps on the board flooring. 
After a moment I stepped forward out of the window recess, and, drawing up 
a chair, sat down beside the girl.
  </p>
<p>
   She dropped her gaze to mine without emotion. I could see her face had 
once been beautiful. From this close view-point I could see, too, that her 
lips were pale with an almost bluish paleness. Her cheeks were very 
white—a whiteness that was not a pallor, but seemingly more an absence 
of red. And then I got the vague, absurd impression that I could see into 
her skin—as though it contained nothing to render it opaque.
  </p>
<p>
   “Do you pose for the
   <i>
    maestro
   </i>
   every night?” I asked. My tone held 
that gentle solicitude with which one might address a child who was very 
ill.
  </p>
<p>
   “
   <i>
    Sí, señor
   </i>
   ; every night at this hour.”
  </p>
<p>
   Her manner was utterly impersonal; her eyes still held that listless, 
apathetic stare. I gazed into them steadily: and then, far down in their 
depths, I seemed to see lurking a shadowy look of appeal.
  </p>
<p>
   “I have been examining your portrait,” I said. “It is a very—curious 
picture, is it not?”
  </p>
<p>
   A faint little glow of color came into the girl’s cheeks. She seemed 
somehow stronger now; but it was a gain of strength rather more mental 
than physical. I sensed dimly that, talking with me, her mind was 
clearing. She hesitated, regarding me appraisingly.
  </p>
<p>
   “A very, very curious portrait indeed it is,
   <i>
    señor
   </i>
   .” Again she 
paused; and then, as though she had come to a sudden decision, she added 
slowly: “A very curious portrait,
   <i>
    señor
   </i>
   . To me it has no meaning. 
Once I said that to the
   <i>
    maestro
   </i>
   , and he was very angry. He told me 
I was mad, because I could not see the art—the wonderful art in his work. 
He beat me then.” She shuddered at the memory. “But that was very long 
ago,
   <i>
    señor
   </i>
   , and never have I said it since. And every night I 
pose.”
  </p>
<p>
   “You are ill,
   <i>
    señorita
   </i>
   ?” I said gently.
  </p>
<p>
   “The portrait needs so much of me,” she answered. And then some thought 
or memory that her words did not reveal made her shudder again. “I am ill,
   <i>
    señor
   </i>
   , as you say. Very ill. And that, too, makes the
   <i>
    maestro
   </i>
   very angry. I am not so beautiful now for the portrait. And 
soon I shall die—and then I can pose no longer.”
  </p>
<p>
   I leaned toward her. “You can trust me,
   <i>
    señorita
   </i>
   ,” I said. “You 
are ill-treated here—he treats you badly?”
  </p>
<p>
   She looked searchingly into my eyes; then she swiftly drew back her 
loose sleeve. The white flesh of her upper arm was scarred with many 
scars.
  </p>
<p>
   “The portrait,
   <i>
    señor
   </i>
   —it is life he paints there. And one cannot 
paint life without using life to paint with. That he says,
   <i>
    señor
   </i>
   —and he takes what there is in me to give.”
  </p>
<p>
   She spoke softly, tremulously, half in terror at her temerity at 
talking thus of the dreaded
   <i>
    maestro
   </i>
   , half with an air of wan 
appeal.
  </p>
<p>
   And with her words, in a sudden flood of horror, the meaning of all 
that I had seen came clear to my mind. I realized 
now how this miserable madman, painting formless daubs upon his canvas, 
was using the life-blood of his victim. With revulsion in my heart, I
understood at last the meaning of those ugly brown smears that mingled and 
predominated among the pigments on the canvas—the dried and faded stains 
of human blood. And here, sitting close beside me, was the victim of this 
insane necromancy—the shell of what had once been womanhood—this body of a 
girl being drained of its life drop by drop.
  </p>
<p>
   The girl’s voice brought me back to myself with a start.
  </p>
<p>
   “He takes the blood that I have to give,
   <i>
    señor
   </i>
   —and each day the 
painting grows more beautiful. He says I am mad that I cannot see its 
beauty—that the brown I see is not brown, but red—vivid, beautiful 
red—the red of life itself.
  </p>
<p>
   “But you,
   <i>
    señor
   </i>
   ”—she put her hand upon mine; its touch hardly 
held the warmth of the living—“you, a stranger who, why I know not, comes 
here to this room—you see, too, the way it looks to me, do you not,
   <i>
    señor
   </i>
   ? Ah, then, indeed I am not mad—and it is he who sees upon the 
canvas what is not there.”
  </p>
<p>
   I was about to answer when dragging footsteps sounded on the stairs; 
the front door of the room opened and the little old man stood upon the 
threshold. A look of incredulous astonishment came over his seared yellow 
face, supplanted in an instant by rage. His lips parted in a snarl.
  </p>
<p>
   “Thou, Malella—thou art here in the presence of a stranger?” He spoke 
in Spanish, his voice vibrating tense with the fierceness of his 
passion.
  </p>
<p>
   The girl turned slowly around on the hassock; the lute slipped from her 
lap to the floor.
  </p>
<p>
   The little old man was coming forward, and the malevolent gleam in his 
eyes made me leap to my feet.
  </p>
<p>
   “Go thou to thy room, Malella—to thy room—at once.”
  </p>
<p>
   The girl rose slowly and stood drooping beside me, as a flower droops 
for long lack of the water that gives it life.
  </p>
<p>
   “
   <i>
    Sí, maestro
   </i>
   ,” she answered. “I go.”
  </p>
<p>
   I saw the old man hold her gaze with his glittering eyes. I realized 
there was about those snakelike little eyes of his an hypnotic power. The 
girl seemed to follow and to obey, involuntarily almost, his unspoken 
commands.
  </p>
<p>
   She laid the lute on the mantel above the fireplace, and, turning 
slowly back, faced the old man as he stood close beside me.
  </p>
<p>
   “Say good night to the gentleman,” he commanded, speaking this time in 
English. He spoke less harshly than before, as though by using my own 
language he unconsciously recognized the restraint my presence put upon 
him.
  </p>
<p>
   Then he added to me, and again the miserable, groveling whine came back 
to his voice:
  </p>
<p>
   “A foolish child,
   <i>
    señor
   </i>
   . You will excuse, of course.”
  </p>
<p>
   “Good night,
   <i>
    señor
   </i>
   ,” said the girl.
  </p>
<p>
   I found myself very near to her, staring straight down into the clear, 
empty depths of her blue eyes. And there again I saw that look of 
appeal—like the patient look of a dog in pain—whispering to me, asking for 
my aid. As if to answer it, all the pent-up torrent of emotion within me 
burst forth. I swept the girl behind me with my arm and fronted the old 
man.
  </p>
<p>
   “I am going now,” I said; and with surprise I heard my voice come quiet 
and repressed. “I thank you, sir, for showing me your painting. The
   <i>
    señorita
   </i>
   here is ill. I am going to take her with me—to-night—to a 
hospital.”
  </p>
<p>
   The old man seemed unable at first to grasp my meaning. He stood 
quavering before me, his lower jaw hanging slack, his eyes widening with 
surprise, a look of confusion on his face.
  </p>
<p>
   “She is going with me now,” I repeated firmly. I turned around to 
her.
  </p>
<p>
   “Get some long wrap, Malella, that will cover you. Hasten—I will wait 
for you here.”
  </p>
<p>
   The girl stood irresolute. Confusion and fear were written on her face; 
her glance swung from one to the other of us, undecided.
  </p>
<p>
   “At once. Malella, do you hear?” I added sharply. “Get your wrap—I will 
wait for you.”
  </p>
<p>
   I pushed her away from me, and she stumbled forward toward the door 
through which she had entered the room.
  </p>
<p>
   Her movement seemed to awaken the little old man into sudden action. He 
flung himself on me with a snarl, his shaking, shriveled fingers clutching 
at my throat. I shook him off, but he came back instantly, throwing 
himself at me fearlessly, with a shrill, maniacal, blood-curdling cry.
  </p>
<p>
   Reason left me; for an instant the room swam red before my eyes. I tore 
his fingers again from my throat, and seizing him around the waist, hurled 
his frail body violently to the floor. His head struck a corner of the 
model stand; his body quivered a moment and then lay still.
  </p>
<p>
   The girl, with livid, terror-stricken face, was shrinking against the 
side wall of the room, with one hand pressed tightly over her mouth. I 
hurried to her.
  </p>
<p>
   “Never mind the wrap, Malella—we will go without it.”
  </p>
<p>
   She looked at me numbly.
  </p>
<p>
   “Come,” I added, and, putting my arm about her shoulders, dragged her 
unresisting from the room.
  </p>
<p>
   It took us but a moment to descend the rickety stairs to the darkened 
shop. I stopped in the shop and snatched up my overcoat and hat. When we 
got to the street I found it had stopped snowing; across the square I 
could see the glistening white of Washington Arch.
  </p>
<p>
   A jolly crowd of young people came hurrying by, and seeing us standing 
there in the doorway—a girl in Moorish costume, and me with my overcoat on 
my arm—laughed and waved in friendly greeting. An alert 
taxi-driver—thinking doubtless we were going to some masquerade—drove his 
car to the curb and stopped.
  </p>
<p>
   “You are safe now, Malella,” I said, after a moment, when we were in 
the taxi and had started toward the hospital uptown.
  </p>
<p>
   Her slim little body swayed toward me; her arms stole up around my neck 
like the arms of a tired, frightened child who seeks protection.
  </p>
<p>
   “You need not be frightened,” I said. “You are never going back.” And 
then I added aloud, but softly, very softly to myself: “For when they make 
you well again at the hospital you are going to be with me—always.”
  </p>
<p>
   For I was in my twenties then, as I have said, and the decisions of 
youth are very quickly reached.
  </p>
<div style="display:block; margin-top:4em">
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 5083101501506010541_67229-h-0.htm.vue?3a00d323